<div class="card">
  <div class="card-body">
    <div class="alert alert-danger alert-dismissible" *ngIf="showAlert">
      <a (click)="closeAlert()" class="close cursor" data-dismiss="alert" aria-label="close">&times;</a>
      {{alertMessage}}
    </div>
    <app-plan-details (invalidPlanEvent)="isValidPlan($event)"></app-plan-details>
  </div>
</div>
